export const IMPORT_STRATEGIES = {
  ALL: "all",
  NEW_ONLY: "new_only",
  UPDATE_ONLY: "update_only",
};

export const IMPORT_STEPS = {
  UPLOAD: "upload",
  MAPPING: "mapping",
  VALIDATION: "validation",
  VALUE_MAPPING: "value_mapping",
  ANALYSIS: "analysis",
  IMPORTING: "importing",
  RESULT: "result",
};

export const REFERENTIAL_TYPES = {
  SOCIAL_REGIMES: "social_regimes",
  EXERCISE_FRAME: "exercise_frame",
  PROFESSION: "profession",
  PROFILES: "profiles",
  SUB_PROFILES: "sub_profiles",
  PROCESSES: "processes",
  RISK: "risk",
  DOCUMENT_TYPE: "document_type",
};

export const REFERENTIAL_QUERY_LIMIT = 100;

export const ACCEPTED_FILE_EXTENSIONS = [".xls", ".xlsx", ".csv"];
export const FILE_ACCEPT_STRING = ".xls,.xlsx,.csv";

export const DEFAULT_RISK = "HEALTH";
export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const CSV_TEMPLATE_HEADERS = [
  "Nom du plan *",
  "Identifiant",
  "Niveau de garantie",
  "Gamme",
  "Risque",
  "Date de début",
  "Date de fin",
  "Description",
  "Alias",
  "Actif",
  "Interne",
  "Autonome",
  "ID externe",
];

export const autoFitColumns = (worksheet, headers) => {
  const MIN_WIDTH = 12;
  const PADDING = 4;
  worksheet["!cols"] = headers.map((header) => ({
    wch: Math.max(String(header).length + PADDING, MIN_WIDTH),
  }));
};

export const resolveError = (err, errorKeys) => {
  if (typeof err === "string") return err;
  if (!err || !err.key) return String(err);
  const template = errorKeys?.[err.key];
  if (!template) return err.key;
  const resolved = Object.entries(err.params || {}).reduce(
    (msg, [k, v]) => msg.replaceAll(`{{${k}}}`, v ?? ""),
    template,
  );
  return resolved.replace(/\s*\{\{[^}]+\}\}/g, "").trim();
};
